import { render, staticRenderFns } from "./NlTermsOfUse.vue?vue&type=template&id=c2243a86&scoped=true"
import script from "./NlTermsOfUse.vue?vue&type=script&lang=js"
export * from "./NlTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c2243a86",
  null
  ,true
)

export default component.exports